<template>
    <div ref="dom" class="c-select flex-between-center" :class="{'z-develop': listPosition, 'z-dis': disabled}"
         @click="developHandle">
        <span class="flex-grow" :class="{'z-empty': !selectedText}">{{ selectedText || placeholder }}</span>
        <i class="tf tf-angle-down"></i>

        <div v-show="listPosition" ref="list" class="c-select-options" :style="listPosition" @click.stop>
            <select-list v-model="selectedValue" :options="optionsList" :default-option="defaultOption"
                         :multiple="multiple"></select-list>
        </div>
    </div>
</template>

<script>
function getStyleComputedProperty(element, property) {
    var css = window.getComputedStyle(element, null);
    return css[property];
}

function getScrollParent(element, fun) {
    var parent = element.parentNode;

    if (!parent) {
        return;
    }
    if (parent === window.document) {
        if (window.document.body.scrollTop || window.document.body.scrollLeft) {
            return fun(window.document.body);
        } else {
            return fun(window);
        }
    }

    if (
            ['scroll', 'auto'].indexOf(getStyleComputedProperty(parent, 'overflow')) !== -1 ||
            ['scroll', 'auto'].indexOf(getStyleComputedProperty(parent, 'overflow-x')) !== -1 ||
            ['scroll', 'auto'].indexOf(getStyleComputedProperty(parent, 'overflow-y')) !== -1
    ) {
        fun(parent);
    }
    return getScrollParent(element.parentNode, fun);
}

function render(h, parent, list, level = 0, option) {
    var arr = [];
    list && list.map(item => {
        item.parent = parent;
        arr = arr.concat([
            <div class={`flex-center-cross c-select-options-item ${!this.multiple && item.value.toString() == this.value.toString() ? 'z-crt' : ''}`}
                 title={item.name} on-click={$event => this.clickHandle(item)}>
                {
                    level ? [
                        <div class="c-select-options-item-level tf tf-level-line"
                             style={`margin-left: ${(level - 1) * 20}px;`}></div>
                    ] : []
                }
                {
                    option.multiple ? [
                        <c-checkbox class="checkbox" checked={!!item._checked}></c-checkbox>
                    ] : []
                }
                {item.name}
            </div>
        ]).concat(render.call(this, h, item, item.children, level + 1, option));
    });

    return arr;
}

const selectList = {
    render(h) {
        return (
                <div>
                    {
                        this.multiple ? [
                            <div class="flex-center-cross c-select-options-item"
                                 on-click={$event => this.clickHandle('all')}>
                                <c-checkbox class="checkbox" checked={this.allChecked}></c-checkbox>
                                全选</div>
                        ] : this.defaultOption ? [
                            <div class="flex-center-cross c-select-options-item" style="color: #aaa;"
                                 on-click={$event => this.clickHandle()}>请选择</div>
                        ] : []
                    }
                    {
                        render.call(this, h, undefined, this.options, 0, {
                            multiple: this.multiple
                        })
                    }
                </div>
        )
    },

    props: {
        value: [String, Number],

        options: Array,

        defaultOption: Boolean,

        multiple: Boolean
    },

    computed: {
        allChecked() {
            return !this.options.find(item => !item._checked);
        }
    },

    methods: {
        clickHandle(item) {
            var that = this;
            if (this.multiple) {
                if (item != 'all') {
                    this.$set(item, '_checked', !item._checked);

                    if (item.children) {
                        !function linkage(list, state) {
                            list.forEach(item => {
                                that.$set(item, '_checked', state);
                                item.children && linkage(item.children, state)
                            })
                        }(item.children, item._checked)
                    }

                    if (item.parent) {
                        !function linkage(item) {
                            that.$set(item, '_checked', !item.children.find(item => !item._checked));
                            item.parent && linkage(item.parent);
                        }(item.parent)
                    }
                }

                let arr = [], state = item == 'all' ? !this.allChecked : undefined;
                !function poll(list) {
                    list.forEach(item => {
                        state !== undefined && that.$set(item, '_checked', state);

                        if (item._checked) {
                            arr.push(item.value);
                        }

                        if (item.children) {
                            poll(item.children)
                        }
                    })
                }(this.options)
                this.$emit('input', arr.join(','));
            } else {
                this.$emit('input', item ? item.value : '');
            }
            this.$parent.clickHandle();
        }
    }
};

export default {
    components: {
        selectList
    },

    props: {
        value: {
            type: [String, Number, Array],
            default: ''
        },

        placeholder: {
            type: String,
            default: '请选择'
        },

        options: {
            type: [Array, String],
            default: () => {
                return [];
            }
        },

        defaultOption: {
            type: Boolean,
            default: true
        },

        multiple: Boolean,

        disabled: Boolean,

        listHeight: {
            type: [Number, String],
            default: 300
        }
    },

    data() {
        return {
            optionsList: [],
            listPosition: false,
            upSeat: false,
            selectedValue: '',
            selectedText: ''
        }
    },

    watch: {
        value() {
            if (!this.optionsList.length) return;
            this.updateSelected();
        },

        options() {
            this.updateOptions();
        }
    },

    mounted() {
        this.options.length && this.updateOptions();
        document.body.appendChild(this.$refs.list);
    },

    beforeDestroy() {
        document.body.removeChild(this.$refs.list);
    },

    methods: {
        updateSelected() {
            var that = this;
            var arr = typeof this.value == 'object' ? this.value || [] : this.value.toString().split(','), value = [],
                    text = [];

            !function poll(list, parent) {
                list.forEach(item => {
                    that.$set(item, '_checked', arr.includes(item.value.toString()));
                    if (item._checked) {
                        value.push(item.value);

                        if (!parent._checked) {
                            text.push(item.name);
                        }
                    }
                    item.children && poll(item.children, item);
                });
            }(this.optionsList, {});

            this.selectedValue = this.multiple ? value.join(',') : (value[0] === undefined ? '' : value[0]);
            this.selectedText = text.join(',');
            this.clickHandle();
        },

        updateOptions() {
            if (typeof this.options == 'string') {
                new Promise(resolve => {
                    switch (this.options) {
                        case 'PRODUCT_CLASSIFY':
                            this.request({
                                url: '/product_type/options',
                                success: data => {
                                    let cache = {};
                                    data.forEach(item => {
                                        if (!cache[item.id]) {
                                            cache[item.id] = {
                                                name: '',
                                                value: 0,
                                                children: []
                                            }
                                        }
                                        cache[item.id].name = item.option;
                                        cache[item.id].value = item.id;

                                        if (item.pid == 0) {
                                            this.optionsList.push(cache[item.id]);
                                        } else {
                                            if (!cache[item.pid]) {
                                                cache[item.pid] = {
                                                    name: '',
                                                    value: 0,
                                                    children: []
                                                }
                                            }
                                            cache[item.pid].children.push(cache[item.id]);
                                        }
                                    });
                                    resolve();
                                }
                            });
                            break;

                        case 'BRAND':
                            this.request({
                                url: '/product_brand/options',
                                success: data => {
                                    this.optionsList = Array.from(data, item => {
                                        return {
                                            name: item.brand_name,
                                            value: item.brand_id
                                        }
                                    });
                                    resolve();
                                }
                            });
                            break;

                        case 'ACTIVITY':
                            this.request({
                                url: '/decoration/activity/list',
                                success: data => {
                                    this.optionsList = Array.from(data, item => {
                                        return {
                                            name: `[${item.activity_type_name}] ${item.activity_name}`,
                                            value: item.activity_id
                                        }
                                    });
                                    resolve();
                                }
                            });
                            break;
                        case 'ABSTRACT_TYPE_ID':
                            this.request({
                                url: '/abstract_consultation_type/options',
                                success: data => {
                                    this.optionsList = Array.from(data, item => {
                                        return {
                                            name: item.name,
                                            value: item.id
                                        }
                                    });
                                    resolve();
                                }
                            });
                            break;

                        case 'MAIN_CATEGORIES':
                            this.request({
                                url: '/dic/options',
                                data: {"dic_type": 'main_categories'},
                                success: data => {
                                    this.optionsList = Array.from(data, item => {
                                        return {
                                            name: item.name,
                                            value: item.name
                                        }
                                    });
                                    resolve();
                                }
                            });
                            break;

                        case 'MANAGEMENT_MODEL':
                            this.request({
                                url: '/dic/options',
                                data: {"dic_type": 'management_model'},
                                success: data => {
                                    this.optionsList = Array.from(data, item => {
                                        return {
                                            name: item.name,
                                            value: item.name
                                        }
                                    });
                                    resolve();
                                }
                            });
                            break;

                        case 'STANTIONED_AUTH':
                            this.request({
                                url: '/stationed/auth/options',
                                data: {"stationed_type": 1},
                                success: data => {
                                    this.optionsList = Array.from(data, item => {
                                        return {
                                            name: item.auth_name,
                                            value: item.id
                                        }
                                    });
                                    resolve();
                                }
                            });
                            break;

                        case 'SELLER_AUTH':
                            this.request({
                                url: '/stationed/auth/options',
                                data: {"stationed_type": 2},
                                success: data => {
                                    this.optionsList = Array.from(data, item => {
                                        return {
                                            name: item.auth_name,
                                            value: item.id
                                        }
                                    });
                                    resolve();
                                }
                            });
                            break;
                        case 'USER_LEVEL_AUTH':          //包含普通用户
                            this.request({
                                url: '/user_level/options',
                                data: {type: 0},
                                success: data => {
                                    this.optionsList = Array.from(data, item => {
                                        return {
                                            name: item.name,
                                            value: item.value
                                        }
                                    });
                                    resolve();
                                }
                            });
                            break;
						case 'USER_LEVEL_AUTH_SELECT':          //包含普通用户
						    this.request({
						        url: '/user_level/options',
						        data: {type: 1},
						        success: data => {
						            this.optionsList = Array.from(data, item => {
						                return {
						                    name: item.name,
						                    value: item.value
						                }
						            });
						            resolve();
						        }
						    });
						    break;
                        case 'MEMBER_LEVEL_AUTH':       //不含普通用户
                            this.request({
                                url: '/user_level/options',
                                data: {"is_common_user":0},
                                success: data => {
                                    this.optionsList = Array.from(data, item => {
                                        return {
                                            name: item.name,
                                            value: item.value
                                        }
                                    });
                                    resolve();
                                }
                            });
                            break;
                        case 'GROWTH_LEVEL_AUTH':
                            this.request({
                                url: '/growth_level/options',
                                data: {},
                                success: data => {
                                    this.optionsList = Array.from(data, item => {
                                        return {
                                            name: item.name,
                                            value: item.value
                                        }
                                    });
                                    resolve();
                                }
                            });
                            break;
                        case 'PRICE_UNIT':
                            this.request({
                                url: '/operation/dic/price_unit/options',
                                data: {},
                                success: data => {
                                    this.optionsList = Array.from(data, item => {
                                        return {
                                            name: item.name,
                                            value: item.name
                                        }
                                    });
                                    resolve();
                                }
                            });
                            break;
                        case 'PRODUCT_REJECT_REASON':
                            this.request({
                                url: '/operation/dic/product_reject_reason/options',
                                data: {},
                                success: data => {
                                    this.optionsList = Array.from(data, item => {
                                        return {
                                            name: item.name,
                                            value: item.name
                                        }
                                    });
                                    resolve();
                                }
                            });
                            break;
                    }//end switch
                }).then(() => {
                    this.updateSelected();
                });
            } else {
                this.optionsList = this.options;
				this.updateSelected();
            }
        },

        developHandle() {
            if (this.listPosition || this.disabled) return;
            this.listPosition = true;
            this.$nextTick(this.updatePosition);
            setTimeout(() => {
                this.updatePosition();
                window.addEventListener('click', this.foldHandle);

                getScrollParent(this.$el, dom => {
                    dom.addEventListener('scroll', this.updatePosition);
                });
            });
        },

        foldHandle() {
            this.listPosition = false;
            window.removeEventListener('click', this.foldHandle);
            getScrollParent(this.$el, dom => {
                dom.removeEventListener('scroll', this.updatePosition);
            });
        },

        clickHandle() {
            this.$emit('input', this.selectedValue);
            this.$emit('change');
            !this.multiple && this.foldHandle();
        },

        updatePosition() {
            let rect = this.$el.getBoundingClientRect();
            let listHeight = this.$refs.list.offsetHeight < this.listHeight ? this.$refs.list.offsetHeight : this.listHeight;
            let up = window.innerHeight - rect.bottom < listHeight;
            this.listPosition = {
                left: rect.left + 'px',
                top: window.scrollY + (up ? rect.top - listHeight + 1 : rect.top + this.$el.offsetHeight - 1) + 'px',
                width: this.$el.offsetWidth + 'px',
                'max-height': this.parsePixel(this.listHeight)
            }
        }
    }
}
</script>

<style lang="stylus">
@import '~@/assets/style/theme';

.c-select {
    position: relative;
    height: 36px;
    border: 1px solid #ddd;
    padding: 0 8px;
    background: #fff;
    cursor: pointer;
    transition: all .3s ease;

    &:not(.z-dis):hover,
    &.z-develop {
        z-index: 100;
        border-color: #bbb;
    }

    &.z-dis {
        background: #f5f5f5;
        cursor: not-allowed;
    }

    span {
        margin-right: 10px;
        overflow: hidden;
        font-size: 14px;
        white-space: nowrap;
        text-overflow: ellipsis;

        &.z-empty {
            color: #ccc;
        }
    }

    &-options {
        box-sizing: border-box;
        z-index: 999;
        position: absolute;
        left: -1px;
        right: -1px;
        top: 100%;
        border: 1px solid #bbb;
        overflow: auto;
        background: #fff;

        &-item {
            padding: 0 8px;
            overflow: hidden;
            line-height: 36px;
            font-size: 13px;
            white-space: nowrap;
            text-overflow: ellipsis;
            cursor: pointer;

            &:hover {
            theme-color(main);
            }

            &.z-crt {
            theme-background(main);
                color: #fff !important;
            }

            &-level {
                width: 15px;
                height: 28px;
                margin-right: 5px;
                text-align: right;
            }

            .checkbox {
                margin-right: 5px;
            }
        }
    }
}
</style>
